import { Grid } from '@mui/material';
import Loading from '../../components/Loading';
import PriorityQueries from './PriorityQueries';
import EmployeePriorityGrid from './EmployeePriorityGrid';
import { useState } from 'react';
import {
  getStoredSelection,
  getStoredProxySelection,
} from '../../components/form/react-hook-form-components/FilterStorage';
import FilterOptions, { IFilterOptions } from '../FilterOptions';
import SelectedRoles from '../management/employees/roles/SelectedRoles';

function Admin() {
  const storageKeyTeam = 'adminTeam';
  const storageKeyRoles = 'adminRoles';
  const storageKeyProxy = 'adminProxy';

  const [filters, setFilters] = useState<IFilterOptions>({
    team: getStoredSelection(storageKeyTeam),
    roles: getStoredSelection(storageKeyRoles),
    proxy: getStoredProxySelection(storageKeyProxy),
  });

  const { data: employees, isLoading } = PriorityQueries().FetchPrioritiesByTeam(
    filters.proxy,
    filters.team?.value,
    undefined,
    undefined,
    SelectedRoles(filters.roles),
    undefined
  );

  /**
   * Maps each employee in the list of employees to an EmployeePriorityGrid
   * @returns
   */
  const displayEmployeePriorityGrid = () => {
    // Show loading indicator while employee data is loading
    if (isLoading) {
      return (
        <Grid item>
          <Loading />
        </Grid>
      );
    }

    // If employees is undefined, then return an informative message
    if (!employees || employees.length === 0) {
      return (
        <Grid item>
          <div>No Employee Priorities to display</div>
        </Grid>
      );
    }

    return employees.map(employee => (
      <Grid item key={employee.id} margin={1}>
        <EmployeePriorityGrid employee={employee} />
      </Grid>
    ));
  };

  return (
    <>
      <FilterOptions state={filters} setState={setFilters} page={'admin'} />
      <Grid container display="flex" direction="column" alignItems="center" rowSpacing={6}>
        {displayEmployeePriorityGrid()}
      </Grid>
    </>
  );
}

export default Admin;
